var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"axj-main"},[_c('axj-tool',{on:{"next":_vm.handleNext,"pre":_vm.handlePre}}),_vm._v(" "),_c('axj-main-top'),_vm._v(" "),_c('axj-main-menu'),_vm._v(" "),_c('axj-main-body')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63e6205c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/axj-main/index.vue
// module id = null
// module chunks = 